import { useState } from 'react';

export default function NextDrop() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setStatus('error');
      setMessage('Please enter your email address');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch('https://readdy.ai/api/form/d6s27bra90d3mf3eh6lg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ email }).toString(),
      });

      if (response.ok) {
        setStatus('success');
        setMessage('You\'re locked in. We\'ll hit you before the next drop.');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('Something went wrong. Try again.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Connection error. Please try again.');
    }
  };

  return (
    <section id="next-drop" className="relative py-32 px-8 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b833599a642dc3c1e4c93f4f291f825d.jpg"
          alt="Next Drop"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/80 to-black/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[900px] mx-auto text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-white/30 rounded-full px-6 py-2 mb-8">
          <span className="text-xs font-bold text-white tracking-wide">NEXT DROP: 03.15</span>
        </div>

        {/* Headline */}
        <h2 className="text-6xl md:text-7xl lg:text-8xl font-black text-white leading-[0.9] tracking-tight mb-8">
          STAY READY<br />
          FOR THE<br />
          <span className="bg-gradient-to-r from-white via-gray-200 to-white bg-clip-text text-transparent">NEXT DROP</span>
        </h2>

        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
          Be first to know about new releases, restocks, and exclusive drops. Join the list and never miss out.
        </p>

        {/* Email Form */}
        <form onSubmit={handleSubmit} className="max-w-[600px] mx-auto mb-8" data-readdy-form id="next-drop-signup">
          <div className="relative flex items-center">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full h-16 bg-[#222222] text-white placeholder-gray-500 px-6 rounded-lg pr-40 focus:outline-none focus:ring-2 focus:ring-white/30 transition-all text-base"
              disabled={status === 'loading'}
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="absolute right-2 bg-white text-black px-10 py-4 rounded-md font-black text-sm hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {status === 'loading' ? 'JOINING...' : 'JOIN THE LIST'}
            </button>
          </div>
        </form>

        {/* Status Message */}
        {status !== 'idle' && (
          <p className={`mb-8 text-sm font-medium ${status === 'success' ? 'text-green-400' : 'text-red-400'}`}>
            {message}
          </p>
        )}

        {/* Social Proof */}
        <p className="text-sm text-gray-500">
          Join 10,000+ members of the BillPlay community
        </p>
      </div>
    </section>
  );
}